import React, { useState } from 'react';
import GroupPage from './GroupPage';
import SubGroupPage from './SubGroupPage';
import UserRolePage from './UserRolePage';
import TrainingMaterialPage from './TrainingMaterialPage';
import Sidebar from '../component/Sidebar';
 
 

function AdminPage() {
  const [activePage, setActivePage] = useState('groups');

  const renderPage = () => {
    switch (activePage) {
      case 'groups':
        return <GroupPage />;
      case 'subgroups':
        return <SubGroupPage />;
 
      case 'roles':
        return <UserRolePage />;
      case 'training':
        return <TrainingMaterialPage />;
      default:
        return <GroupPage />;
    }
  };

  return (
    <div className="flex h-screen">
      <Sidebar setActivePage={setActivePage} />
      <div className="flex-1 overflow-y-auto p-6">{renderPage()}</div>
    </div>
  );
}

export default AdminPage;
